import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

export function ValuePropCard({
  icon,
  heading,
  description,
  buttonText,
  buttonAction,
  className,
  headingClassName,
  descriptionClassName,
  buttonDisabled,
}: {
  icon: string;
  heading: string;
  description: ReactNode;
  buttonText?: string | null;
  buttonAction?: (() => void) | null;
  buttonDisabled?: boolean;
  className?: string;
  headingClassName?: string;
  descriptionClassName?: string;
}) {
  return (
    <Card className={cn('p-4', className)}>
      <div className="flex items-center gap-4">
        <div className="text-8xl">{icon}</div>
        <div className="flex flex-col items-start gap-2">
          <div
            className={cn('text-xl font-bold leading-none', headingClassName)}
          >
            {heading}
          </div>
          <div className={cn('text-sm', descriptionClassName)}>
            {description}
          </div>
          {buttonText && buttonAction && (
            <Button onClick={buttonAction} disabled={buttonDisabled}>
              {buttonText}
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}
